const getFilterData = state  => state.filterData;
const isFilterLoading = state  => state.isFilterLoading;

/**
 * 계약별 사용률 목록
 * @param state
 * @returns {{totalCount: number, list: []}|string|default.watch.agreementUtilizationList}
 */
const getAgreementUtilizationList = state  => state.agreementUtilizationList;
const isAgreementUtilizationListLoading = state => state.isAgreementUtilizationListLoading;

/**
 * 계약별 상세
 * @param state
 * @returns {*}
 */
const getAgreementUtilizationDetail = state  => state.agreementUtilizationDetail;
const isAgreementUtilizationDetailLoading = state => state.isAgreementUtilizationDetailLoading;


/**
 * 인스턴스 패밀리별 사용률 목록
 * @param state
 * @returns {{totalCount: number, list: []}|string}
 */
const getInstanceFamilyUtilizationList = state  => state.instanceFamilyUtilizationList;
const isInstanceFamilyUtilizationListLoading = state => state.isInstanceFamilyUtilizationListLoading;

/**
 * 서비스별 사용률 목록
 * @param state
 * @returns {{totalCount: number, list: []}}
 */
const getServiceUtilizationList = state  => state.serviceUtilizationList;
const isServiceUtilizationListLoading = state => state.isServiceUtilizationListLoading;

const getTotalSummary = state  => state.totalSummary;
const isTotalSummaryLoading = state => state.isTotalSummaryLoading;

const getTransition = state  => state.transition;
const isTransitionLoading = state => state.isTransitionLoading;

const selectedMonthToDate = state => {
  return state.selectedMonthToDate
};
const selectedViewByOption = state => {
  return state.selectedViewByOption
};
const selectedVendor = state => state.selectedVendor;

export default {
  selectedMonthToDate,
  selectedViewByOption,
  selectedVendor,
  getFilterData: getFilterData,
  isFilterLoading,
  getAgreementUtilizationList: getAgreementUtilizationList,
  isAgreementUtilizationListLoading,
  getAgreementUtilizationDetail: getAgreementUtilizationDetail,
  isAgreementUtilizationDetailLoading,
  getInstanceFamilyUtilizationList: getInstanceFamilyUtilizationList,
  isInstanceFamilyUtilizationListLoading,
  getServiceUtilizationList: getServiceUtilizationList,
  isServiceUtilizationListLoading: isServiceUtilizationListLoading,
  getTotalSummary,
  isTotalSummaryLoading,
  getTransition,
  isTransitionLoading
};



// WEBPACK FOOTER //
// ./src/store/modules/azure-reserved/azure-utilization/getters.js